import { useQuery } from '@tanstack/react-query';
import { accessControlAction } from '@/lib/api';
import { useDeviceStore } from '@/stores/deviceStore';
import type { AccessPolicy } from '@/types';

export function useAccessPolicy(deviceId?: string) {
  const { activeDeviceId } = useDeviceStore();
  const targetDeviceId = deviceId || activeDeviceId;

  return useQuery({
    queryKey: ['access-policy', targetDeviceId],
    queryFn: async (): Promise<AccessPolicy | null> => {
      if (!targetDeviceId) return null;

      const result = await accessControlAction<AccessPolicy>('get-policy', {
        device_id: targetDeviceId,
      });

      if (result.error) return null;
      return result.data;
    },
    enabled: !!targetDeviceId,
    staleTime: 60_000,
  });
}
